module.exports = __webpack_public_path__ + "img/bo.2a3ea99f.svg";